<template>
  <div>
    <!-- Label -->
    <label v-if="label" :for="name" class="inputLabel">
      {{ label }}
      <span v-if="required" class="requiredStar">*</span>
    </label>

    <!-- Textarea Input -->
    <div class="inputWrapper">
      <textarea
        @input="handleChange"
        @keydown="onKeydown"
        @paste="onPaste"
        data-hj-allow
        :name="name"
        :placeholder="placeholder"
        :id="id"
        ref="textarea"
        :required="required"
        :value="inputValue"
        :style="'height: ' + height"
        :class="
          error && touched
            ? 'customInput customTextarea inputError'
            : 'customInput customTextarea'
        "
      ></textarea>
      <div class="countArea noselect" :class="error ? 'countError' : ''">
        <span v-if="limit > 0">{{ characterCount }} / {{ limit }}</span>
        <span v-if="!limit || limit === 0">{{ characterCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  data() {
    return {
      touched: false,
      error: false,
      errorText: this.label + ' is required',
      success: false,
      inputValueModel: null,
      characterCount: 0,
    };
  },
  watch: {
    value: function() {
      this.characterCount = this.inputValue.length;
      this.inputValueModel = this.value;
    },
  },
  computed: {
    inputValue() {
      if (!this.inputValueModel && this.inputValueModel !== '') {
        return this.value;
      }
      return this.inputValueModel;
    },
  },
  mounted() {
    if (this.inputValue) {
      this.characterCount = this.inputValue.length;
    } else {
      this.characterCount = 0;
    }
  },
  methods: {
    handleChange(e) {
      this.characterCount = e.target.value.length;
      const value = e.target.value;
      this.inputValueModel = value;

      this.$emit('input-change', { key: this.name, value });
      if (value && value !== '') {
        this.success = true;
        this.error = false;
        this.$emit('error-change', false);
        this.$refs.textarea.classList.remove('inputError');
        return;
      }

      if (this.required) {
        this.success = false;
      }

      this.$emit('error-change', true);
      return (this.error = 'error');
    },
    onKeydown(e) {
      if (this.limit && this.limit > 0) {
        if (this.characterCount >= this.limit) {
          if (
            e.keyCode !== 8 &&
            e.keyCode !== 38 &&
            e.keyCode !== 39 &&
            e.keyCode !== 40 &&
            e.keyCode !== 41 &&
            e.keyCode !== 46 &&
            e.keyCode !== 16 &&
            e.keyCode !== 17 &&
            e.keyCode !== 18
          ) {
            e.preventDefault();
          }
        }
      }
    },
    onPaste(e) {
      var text = e.clipboardData.getData('text/plain');
      let strLen = text.length;
      if (this.characterCount + strLen > this.limit) {
        let selectionLength = 0;
        if (window.getSelection()) {
          selectionLength = window
            .getSelection()
            .getRangeAt(0)
            .toString().length;
        }
        let newtext = text.slice(
          0,
          this.limit - this.characterCount + selectionLength
        );
        document.execCommand('insertHTML', false, newtext.trim());
        e.preventDefault();
      } else {
        document.execCommand('insertHTML', false, text.trim());
        e.preventDefault();
      }
    },
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
      default: 0,
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    styles: {
      type: String,
      default: '',
    },
    marginTop: {
      type: Boolean,
      default: false,
    },
    showSearchSelect: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '120px',
    },
  },
};
</script>

<style lang="scss" scoped>
.customTextarea {
  min-height: 100px;
}
.countArea {
  float: right;
  right: 8px;
  bottom: 12px;
  font-size: 12px;
  line-height: 18px;
  color: #969ba0;
  background: transparent;
  padding: 0 5px;
  border-radius: 5px;
  font-weight: 600;
}
</style>
